import React, { useState } from "react";
import styles from "./SellerPicksManagement.module.scss";
import DynamicTableFilters from "../../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters";
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";
import { sellerPicksManagementTableData as initialData } from "../../../../../views/AdminPortal/dummyData";
import StatusBadge from "../../../../common/AdminCommonComponents/StatusBadge/StatusBadge";
import ActionButton from "../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton";
import Toggle from "../../../../common/AdminCommonComponents/Toggle/Toggle";

const SellerPicksManagement = () => {
    const [tableData, setTableData] = useState(initialData);

    const handleToggleChange = (index) => {
        setTableData((prevData) =>
            prevData.map((item, i) =>
                i === index ? { ...item, toggleState: !item.toggleState } : item
            )
        );
    };

    const options = [
        { label: "Delete" },
        { label: "Change status" },
    ];

    const columns = [
        {
            name: "Sr.",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "Pick ID",
            selector: (row) => row.pickId,
            center: "true",
        },
        {
            name: "Product Name",
            selector: (row) => row.productName,
            center: "true",
            minWidth: "150px",
        },
        {
            name: "Seller ID",
            selector: (row) => row.sellerId,
            center: "true",
        },
        {
            name: "Category",
            selector: (row) => row.category,
            center: "true",
            minWidth: "160px",
        },
        {
            name: "Status",
            cell: (row) => <StatusBadge statusName={row.status} />,
            center: "true",
        },
        {
            name: "Start Date",
            selector: (row) => row.startDate,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "End Date",
            selector: (row) => row.endDate,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Status",
            cell: (row, index) => (
                <Toggle
                    theme="yellow"
                    checked={row.toggleState}
                    onChange={() => handleToggleChange(index)}
                />
            ),
            center: "true",
        },
        {
            name: "Actions",
            cell: () => <ActionButton options={options} />,
            center: "true",
        },
    ];

    const handleApply = (filters) => {
        console.log("Applied Filters:", filters);
    };

    const handleClear = () => {
        console.log("Filters Cleared");
    };

    return (
        <div className={styles.sellerPicksContainer}>
            <div className={styles.filterTableWrapper}>
                <h5 className={styles.sectionHeading}>Seller Picks Management</h5>
                <DynamicTableFilters
                    componentName={"Seller Picks Management"}
                    onApply={handleApply}
                    onClear={handleClear}
                />
                <div className={styles.tableWrapper}>
                    <DynamicDatatable
                        data={tableData}
                        columns={columns}
                        type="gray"
                        pagination
                        highlightOnHover
                        responsive
                    />
                </div>
            </div>
        </div>
    );
};

export default SellerPicksManagement;